import React from "react";
import DashboardLayout from "@pma/app/dashboard/layout";
import { useParams } from "react-router-dom";
import { EstimateBoQDetails } from "@pma/components/financials/estimate-boq-details";

const EstimateBoQDetailPage = () => {
  const params = useParams();
  const boqId = String(params?.boqId);

  return (
    <DashboardLayout>
      <EstimateBoQDetails boqId={boqId} />
    </DashboardLayout>
  );
};

export default EstimateBoQDetailPage;
